import styled from "vue-styled-components";

export const CMobileMenu = styled.div`
    background-color: ${props =>
        props.theme?.header?.menu_mobile?.background_color ?? "#000000"};

    .mobile-menu-close {
        color: ${props => props.theme?.header?.menu_mobile?.color ?? "#fff"};
    }

    .mobile-menu {
        border-bottom: 1px solid
          ${props => props.theme?.header?.menu_mobile?.border_color ?? "#242527"};

            .mmenu-btn {
                color: ${props =>
                    props.theme?.header?.menu_mobile?.color ?? "#fff"};
            }
        }

        li {
            border-top: 1px solid
                ${props => props.theme?.header?.menu_mobile?.border_color ?? "#242527"};

            a {
                color: ${props =>
                    props.theme?.header?.menu_mobile?.color ?? "#fff"};
            }
        }
    }
`;
